<template>
	<div class="w-full px-3 py-2.5 text-sm">
		<slot />
	</div>
</template>
